const uiState = {
    sidebarVisible: false,
}

const uiReducer = (state = uiState, action) => {
    switch (action.type) {
        case 'TOGGLE_SIDEBAR':
            return Object.assign({}, state, {
                sidebarVisible: !state.sidebarVisible
            })

        default:
            return state
    }
}

export default uiReducer


// WEBPACK FOOTER //
// ./src/reducers/uiReducer.js